import { serverInfoFn } from "../common/openapi";

import type { UseFullQueryOptions } from "./react-query";

export const queryServerInfo = {
	queryKey: ["server", "info"],
	queryFn: () => serverInfoFn({}),
} as const satisfies UseFullQueryOptions;
